import moment from 'moment';
import { getProjectStatuses } from '../../HttpRequests/projectStatuses';
import { loadProjectStatuses } from '../State/projectStatuses';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getProjectStatuses();

    dispatch(loadProjectStatuses(response.data.data));

  } catch (error) {
    
    throw error;

  }
}